import { useContext } from "react";
import { AppContext } from "@/App";
import { motion } from "framer-motion";

const STRINGS = {
  it: {
    label: "Come funziona",
    title: "Tre passi, zero pensieri",
    steps: [
      { n: "01", title: "Prenoti in 30 secondi", desc: "Preventivo istantaneo e prezzo bloccato. Nessun supplemento, mai." },
      { n: "02", title: "Ricevi conferma", desc: "Email immediata e promemoria WhatsApp due ore prima della corsa." },
      { n: "03", title: "Viaggi", desc: "Il tuo chauffeur arriva in anticipo e ti aspetta in aeroporto con cartello. Paghi online o a bordo." },
    ],
  },
  en: {
    label: "How it works",
    title: "Three steps, zero worries",
    steps: [
      { n: "01", title: "Book in 30 seconds", desc: "Instant quote and locked price. No surcharges, ever." },
      { n: "02", title: "Get confirmation", desc: "Immediate email and a WhatsApp reminder two hours before your ride." },
      { n: "03", title: "Travel", desc: "Your chauffeur arrives early and greets you at arrivals with a name sign. Pay online or on board." },
    ],
  },
};

export default function HowItWorks() {
  const { lang } = useContext(AppContext);
  const s = STRINGS[lang];
  return (
    <section data-testid="how-it-works-section" className="mx-auto max-w-7xl px-4 py-24 sm:px-6">
      <p className="label-accent">{s.label}</p>
      <h2 className="font-display mt-3 text-3xl font-medium text-amber-100/90 sm:text-4xl">{s.title}</h2>
      <div className="mt-14 grid gap-10 md:grid-cols-3">
        {s.steps.map((step, i) => (
          <motion.div
            key={step.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="relative border-t border-[rgba(212,175,55,0.25)] pt-8"
          >
            <span className="font-display absolute -top-7 left-0 text-6xl font-medium text-[rgba(212,175,55,0.25)]">
              {step.n}
            </span>
            <h3 className="font-display mt-6 text-xl font-semibold text-white">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-neutral-400">{step.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
